import { FormattedMessage } from 'react-intl';

import HistoryResumeItem from 'components/HistoryResumeItem';

import historyResumeConfigs from './historyResumeConfigs';

import { HistoryResumeProps } from './types';

import * as S from './styles';

export const HistoryResume: React.FC<HistoryResumeProps> = ({
  data,
  loading,
}) => {
  return (
    <S.ResumeContainer data-testid="historyLoading">
      <S.ResumeTitle data-testid="resumeTitle">
        <FormattedMessage id="SESSION.HISTORY.CP.TITLE.TOTAL" />
      </S.ResumeTitle>
      {historyResumeConfigs(data)
        .filter(config => typeof config.amount === 'number' || loading)
        .map(({ key, title, amount, icon, tooltip, accepted }) => {
          return (
            <HistoryResumeItem
              key={key}
              icon={icon}
              dataKey={key}
              title={title}
              amount={amount}
              loading={loading}
              tooltip={tooltip}
              accepted={accepted}
            />
          );
        })}
    </S.ResumeContainer>
  );
};
